/*
 * @Author: zl
 * @Date: 2022-03-16 10:02:03
 * @LastEditTime: 2022-03-16 10:14:42
 * @LastEditors: zl
 * @Description: 形象进度模板相关接口
 */
import request from '../request.js'


/**
 * 描述： 形象进度模板 - 新增或编辑形象进度模板
 * 接口管理员： 崔北超
 * 参数：{}
 */
export const saveOrUpdateTemplateSchedule = function (data) {
    return request({
        url: 'opeTemplateSchedule/saveOrUpdateTemplateSchedule',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}


/**
 * 描述： 形象进度模板 - 查询合同结构
 * 接口管理员： 崔北超
 * 参数：{}
 */
export const selectTemplateSchedule = function (data) {
    return request({
        url: 'opeTemplateSchedule/selectTemplateSchedule',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 形象进度模板 - 删除合同结构
 * 接口管理员： 崔北超
 * 参数：{}
 */
export const deleteTemplateSchedule = function (data) {
    return request({
        url: 'opeTemplateSchedule/deleteTemplateSchedule',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 形象进度模板 - 修改是否生效的状态
 * 接口管理员： 崔北超
 * 参数：{}
 */
export const setStatus = function (data) {
    return request({
        url: 'opeTemplateSchedule/setStatus',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述： 形象进度模板 - 上移或下移合同结构
 * 接口管理员： 崔北超
 * 参数：{}
 */
export const upOrDownTemplateSchedule = function (data) {
    return request({
        url: 'opeTemplateSchedule/upOrDownTemplateSchedule',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}